/* eslint-disable import/prefer-default-export */
import { businessFlags } from '../config/config.front.json';

export const businessFlagValidation = () => {
  const countriesEnable = businessFlags.find((items) => items.name === 'countryCodeValidate');
  const { countries } = countriesEnable;
  return countries;
};
